import React, { Component } from "react";
import HeaderMenu from '../Components/HeaderMenu'
import Footer from '../Components/Footer/Footer'
import Discussionbody from './Discussionbody'

const Discussion = () => {
  return (
    <div className="">
      <HeaderMenu />
      <Discussionbody />
      <Footer />
    </div>
  );
}

export default Discussion;
